import {InstrumentedTimeoutProvider} from '../../../libs/shared/helpers/src/instrumentation/timeout';
import {patchRawBoot, RawBoot, RawBootDelta} from '../../../src/models/api/rawBootModel';
import {readRawBootCacheAsync} from './rawBootCache';

/*
 * Helpers.
 */

type RawBootDeltaProvider = (
  cachedRawBoot: RawBoot,
) => Promise<RawBootDelta | undefined> | RawBootDelta | undefined;

export async function maybeReadAndPatchRawBootCacheAsync(
  timeoutProvider: InstrumentedTimeoutProvider,
  fetchRawBootDeltaAsync: RawBootDeltaProvider,
  onPatchError?: () => void,
): Promise<RawBoot | undefined> {
  // Read a full raw boot from the cache, with a timeout to hedge against I/O issues.
  const cachedRawBoot = await readRawBootCacheAsync(timeoutProvider);

  if (!cachedRawBoot) {
    return undefined;
  }

  // Fetch and decode a raw boot delta.
  const rawBootDelta = await fetchRawBootDeltaAsync(cachedRawBoot);

  if (!rawBootDelta) {
    onPatchError?.();
    return undefined;
  }

  // Try to patch the full raw boot.
  return patchRawBoot(cachedRawBoot, rawBootDelta);
}
